import { SpeakerIcon } from "../../../materials/icons/speaker-icon/SpeakerIcon";
import { shade900 } from "../../../styles/tokens";
import { IconButton, Props } from "./SpeakerIconButton.Parts";

export const SpeakerIconButton = ({ $muted, ...props }: Props) => (
  <IconButton {...props}>
    <SpeakerIcon $muted={$muted} $maskFill={shade900} />
  </IconButton>
);
